'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Camera, Trophy, Package, Utensils } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const gridItems = [
{
  icon: <Camera size={24} className="text-[#4caf7d]" />,
  title: 'Có ảnh đẹp và video recap sau chương trình',
  desc: 'Sau hành trình, sinh viên sẽ có ảnh hoạt động, ảnh tập thể, video recap và các tư liệu hình ảnh có thể lưu giữ, chia sẻ hoặc sử dụng cho hồ sơ cá nhân.',
  color: '#4caf7d',
  position: 'top-left'
},
{
  icon: <Trophy size={24} className="text-[#e8a030]" />,
  title: 'Có cơ hội được vinh danh cá nhân hoặc theo nhóm',
  desc: 'Những cá nhân hoặc nhóm có phần thể hiện nổi bật, có tinh thần tốt hoặc có nội dung truyền thông ấn tượng sẽ có cơ hội được ghi nhận và vinh danh trong chương trình.',
  color: '#e8a030',
  position: 'top-right'
},
{
  icon: <Package size={24} className="text-[#a8d87a]" />,
  title: 'Được hỗ trợ vật dụng cơ bản trong suốt chương trình',
  desc: 'Sinh viên được hỗ trợ các vật dụng cần thiết để tham gia hoạt động, giúp hành trình diễn ra thuận tiện hơn và giảm bớt áp lực chuẩn bị cá nhân.',
  color: '#a8d87a',
  position: 'bottom-left'
},
{
  icon: <Utensils size={24} className="text-[#f5c96a]" />,
  title: 'Được hỗ trợ ăn uống trong suốt chương trình',
  desc: 'Các bữa ăn được bố trí theo kế hoạch chương trình, giúp sinh viên yên tâm tham gia trọn vẹn. Đồng thời, đây cũng là một phần của trải nghiệm, nơi các bạn được cảm nhận đời sống bản địa và sự gắn kết tập thể trong suốt hành trình.',
  color: '#f5c96a',
  position: 'bottom-right'
}];


export default function Slide15bGrid({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0f2318]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1632215863479-201029d93143"
          alt="Sinh viên chụp ảnh kỷ niệm và vui vẻ trong hoạt động ngoại khóa ngoài trời, khoảnh khắc đáng nhớ"
          className="w-full h-full object-cover opacity-8" />

        <div className="absolute inset-0 bg-gradient-to-br from-[#1a3a2a]/50 via-[#0f2318] to-[#0f2318]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[rgba(76,175,125,0.03)] blur-3xl" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge">Quyền lợi sinh viên</div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            Quyền lợi dành cho sinh viên
          </h2>
        </div>

        <div className="fade-in-up mb-10">
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 fade-in-up">
          {gridItems.map((item, i) =>
          <div
            key={`grid-benefit-${i}`}
            className="rounded-2xl p-7 flex flex-col transition-all duration-300 hover:-translate-y-1"
            style={{
              background: `linear-gradient(145deg, ${item.color}12 0%, ${item.color}04 100%)`,
              border: `1px solid ${item.color}28`
            }}>

              <div className="flex items-start gap-4 mb-4">
                <div
                className="p-3 rounded-xl inline-flex flex-shrink-0"
                style={{ background: `${item.color}18` }}>

                  {item.icon}
                </div>
                <h3
                className="font-display font-700 text-[16px] lg:text-[18px] leading-snug"
                style={{ color: item.color }}>

                  {item.title}
                </h3>
              </div>
              <p className="font-body text-[13px] lg:text-[14px] text-[#a0b8a8] leading-relaxed">
                {item.desc}
              </p>
            </div>
          )}
        </div>
      </div>
    </SlideWrapper>);

}